import { Button } from "src/components/ui-components/Button/Button";
import modal from "src/components/ui-components/Modal/ModalContent.module.css";
import { useDeleteDataset } from "../hooks/useDeleteDataset";

export const DeleteDatasetModalContent = ({
  onDismiss,
  tableName,
}: {
  tableName: string;
  onDismiss: () => void;
}) => {
  const { onDelete, isLoading } = useDeleteDataset({
    tableName,
    onComplete: onDismiss,
  });

  return (
    <div className={modal.body}>
      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>
            Deleting a dataset will break all queries and dashboards that rely
            on it.
          </h2>
        </div>
      </div>

      <div className={modal.buttons}>
        <Button size="M" theme="tertiary" onClick={onDismiss}>
          Cancel
        </Button>

        <Button size="M" theme="danger" onClick={onDelete} disabled={isLoading}>
          Delete dataset
        </Button>
      </div>
    </div>
  );
};
